export const FETCH_BOOKINGS_ACTION = "FETCH_BOOKINGS"
export const FETCH_BOOKINGS_SUCCESS_ACTION = "FETCH_BOOKINGS_SUCCESS"
export const FETCH_BOOKINGS_ERROR_ACTION = "FETCH_BOOKINGS_ERROR"
export const TOGGLE_BOOKINGS_HISTORY_ACTION = "TOGGLE_BOOKINGS_HISTORY"
